document.addEventListener("DOMContentLoaded", () => {
  var menu = new Mmenu("#mobile-menu", {
      "extensions": ["position-right"],
      "hooks": {
          "open:before": () => {
              jQuery(".hamburger").addClass('is-active');
          },
          "close:before": () => {
              jQuery(".hamburger").removeClass('is-active');
          }
      },
      offCanvas: {
          position: "right",
          page: {
              selector: "#page_wrapper"
          }
      }
  });

  jQuery('.mm-navbar__title').attr('href', '#');

  jQuery('.mm-wrapper__blocker').on('click', () => {
      menu.API.close();
  });
});
